export default class NavigationBar {
    hideNavigation = false;
    lastScrollTop = 0;
    scrollUpThreshold = 200; // Minimum scroll-up distance before showing the nav

    init() {
        window.addEventListener("scroll", () => this.menuScrolling());
    }

    menuScrolling() {
        if (window.innerWidth >= 768) {
            this.hideNavigation = false;
            return;
        }

        let st = window.scrollY;

        if (st > this.lastScrollTop) {
            // Scrolling Down
            if (st >= 200) {
                this.hideNavigation = true;
            }
            this.lastScrollTop = st; // Only update on scroll down
        } else {
            // Scrolling Up
            if (this.lastScrollTop - st >= this.scrollUpThreshold) {
                this.hideNavigation = false;
                this.lastScrollTop = st; // Only update after reaching threshold
            }
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("navigationBar", () => new NavigationBar());
});